import { FormGroup } from '@angular/forms';

export class ResetPassword {
  static ResetPassword(registrationFormGroup: FormGroup) {
      
        const password = registrationFormGroup.controls.Password.value;
        const confirmPassword = registrationFormGroup.controls.ConfirmPassword.value;

        if (password !== confirmPassword) {
            registrationFormGroup.controls.ConfirmPassword.setErrors({ ResetPassword: true });
        } else {
            registrationFormGroup.controls.ConfirmPassword.setErrors(null);
        }
  }
}
